module.exports = __webpack_public_path__ + "static/media/App Store desktop.6694aabb.png";